import { render, staticRenderFns } from "./ActivitySubmissionLearner.vue?vue&type=template&id=1d5e595e"
import script from "./ActivitySubmissionLearner.vue?vue&type=script&lang=js"
export * from "./ActivitySubmissionLearner.vue?vue&type=script&lang=js"
import style0 from "./ActivitySubmissionLearner.vue?vue&type=style&index=0&id=1d5e595e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports